export default {
    init: function () {
        if ($('.resource-button').length === 0) return;

        this.bindEvents();
    },


    handleOpenResource: function ($$) {

        //set URL param
        let refresh = window.location.protocol + '//' + window.location.host + window.location.pathname + `?modal=true`;
        window.history.pushState({path: refresh}, '', refresh);
    },

    bindEvents: function () {

        let _this = this;
        $('.resource-button').on('click', function () {
            if (!$(this).data('target-modal')) return;
            _this.handleOpenResource(this);
        });

    },

};
